import template from './index.jst';
import './index.styl';
import { StatsItem } from '../../../views';

export class GeneralStats extends StatsItem {
	get template() {
		return template;
	}

	get className() {
		return 'general-stats';
	}

	initialize() {
		super.initialize();
		const rounds = this.model.get('rounds'),
			{ actual, points_round, last_completed } = rounds;

		this.model.set({ current_round: actual, points_round, last_completed });
	}
}
export default GeneralStats;